import { createLink } from '@tanstack/react-router';

import { Link } from '@brightlocal/ui-components/link';

/** DS Link wrapped with TanStack Router's `createLink` for type-safe internal navigation (typed `to`, `search`, and `params` props). */
export const RouterLink = createLink(Link);
